import { useEffect, useRef } from "react";
import Cal, { getCalApi } from "@calcom/embed-react";
import ModalBasicLayout from "./ModalBasicLayout";
import Box from "@mui/material/Box";
import { useTranslationApp } from "../../lib/i18next";
import { useDispatchApp } from "../../lib/redux";
import i18next from "i18next";
import { pickLocalizedValue } from "../../utils/i18nLanguage";
import { startSaveSupportSession } from "../../actions/supportSessions";
import {
  MODAL_AD_HOC_SUPPORT_ARIA_LABEL,
  MODAL_AD_HOC_SUPPORT_DESCRIPTION,
  MODAL_AD_HOC_SUPPORT_TITLE,
} from "../../i18n/keysTranslations";

const CAL_AD_HOC_SUPPORT_LINK_EN =
  "team/customer-success-adle/ad-hoc-support-session-clients";
const CAL_AD_HOC_SUPPORT_LINK_ES = "team/customer-success-adle/soporte-adle";
const CAL_AD_HOC_SUPPORT_NAMESPACE = "adHocSupport";
const CAL_BOOKING_SUCCESS_ACTIONS = [
  "bookingSuccessful",
  "bookingSuccessfulV2",
];

const ModalAdHocSupport = ({ modalOpen = false, onCloseModal = () => {} }) => {
  const dispatch = useDispatchApp();
  const { t } = useTranslationApp();
  const hasSavedBookingRef = useRef(false);
  const calLink = pickLocalizedValue(i18next.language, {
    en: CAL_AD_HOC_SUPPORT_LINK_EN,
    es: CAL_AD_HOC_SUPPORT_LINK_ES,
  });

  useEffect(() => {
    if (!modalOpen) {
      hasSavedBookingRef.current = false;
      return;
    }

    let isMounted = true;

    const onBookingSuccessful = async () => {
      if (hasSavedBookingRef.current) {
        return;
      }

      hasSavedBookingRef.current = true;

      const result = await dispatch(startSaveSupportSession());

      if (result?.ok) {
        onCloseModal();
      } else {
        hasSavedBookingRef.current = false;
      }
    };

    const onInitCalUi = async () => {
      const cal = await getCalApi({ namespace: CAL_AD_HOC_SUPPORT_NAMESPACE });
      if (!isMounted) return;

      cal("ui", {
        theme: "light",
        hideEventTypeDetails: true,
        styles: {
          body: { background: "transparent" },
        },
        cssVarsPerTheme: {
          light: {
            "cal-bg": "#ffffff",
          },
        },
      });

      CAL_BOOKING_SUCCESS_ACTIONS.forEach((action) => {
        cal("on", {
          action,
          callback: onBookingSuccessful,
        });
      });
    };

    onInitCalUi();

    return () => {
      isMounted = false;
    };
  }, [dispatch, modalOpen, onCloseModal]);

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      fullWidth
      maxWidth="md"
      scroll="paper"
      showCloseButton
      ariaLabel={t(MODAL_AD_HOC_SUPPORT_ARIA_LABEL)}
      title={t(MODAL_AD_HOC_SUPPORT_TITLE)}
      description={t(MODAL_AD_HOC_SUPPORT_DESCRIPTION)}
      sxContent={{
        overflow: "hidden",
        pb: 3,
      }}
    >
      <Box
        sx={{
          overflow: "hidden",
          position: "relative",
          width: "100%",
          height: 600,
        }}
      >
        {modalOpen ? (
          <Cal
            key={calLink}
            namespace={CAL_AD_HOC_SUPPORT_NAMESPACE}
            calLink={calLink}
            style={{ width: "100%", height: "100%", overflow: "scroll" }}
            config={{
              layout: "month_view",
              theme: "light",
            }}
          />
        ) : null}
      </Box>
    </ModalBasicLayout>
  );
};

export default ModalAdHocSupport;
